import { analyticsClient } from '../lib/client';
import { ANALYTICS_ENDPOINTS } from './routes';
import type {
    LiveCallsResponse,
    AverageHandlingTimeResponse,
    VolumeTrendsResponse,
    CallEndingsResponse,
    DateRangeParams,
    VolumeTrendsParams,
    RubricAnalyticsParams,
    VolumeTrendsRubricParams
} from './types';

export const getLiveCalls = async () => {
    try {
        const response = await analyticsClient.get<LiveCallsResponse>(
            ANALYTICS_ENDPOINTS.LIVE_CALLS
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to fetch live calls' };
    }
};

export const getAverageHandlingTime = async (params: DateRangeParams | RubricAnalyticsParams = {}) => {
    try {
        const response = await analyticsClient.get<AverageHandlingTimeResponse>(
            ANALYTICS_ENDPOINTS.AVERAGE_HANDLING_TIME,
            { params }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to fetch average handling time' };
    }
};

export const getVolumeTrends = async (params: VolumeTrendsParams | VolumeTrendsRubricParams) => {
    try {
        if (!params.granularity) {
            throw new Error('Granularity is required for volume trends');
        }

        const response = await analyticsClient.get<VolumeTrendsResponse>(
            ANALYTICS_ENDPOINTS.VOLUME_TRENDS,
            { params }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to fetch volume trends' };
    }
};

export const getCallEndings = async (params: DateRangeParams | RubricAnalyticsParams = {}) => {
    try {
        const response = await analyticsClient.get<CallEndingsResponse>(
            ANALYTICS_ENDPOINTS.CALL_ENDINGS,
            { params }
        );
        return { data: response.data };
    } catch (error) {
        return { error: error instanceof Error ? error.message : 'Failed to fetch call endings' };
    }
};
